(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["donkey-logo-scroller"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-section-type="donkey-logo-scroller"] .scroller').forEach(function (scroller) {
      scroller.setAttribute('data-animated', 'false');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["donkey-product"]) return;
  try {
    
  if (!customElements.get('donkey-product-video')) {
    customElements.define('donkey-product-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        const medium = (window.theme && window.theme.sizes && window.theme.sizes.medium) || 768;
        this.desktop = window.matchMedia(`(min-width: ${medium + 1}px)`);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.update = this.update.bind(this);
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[entries.length - 1].isIntersecting;
          this.update();
        }, { threshold: 0.5 });
        this.observer.observe(this);
        this.desktop.addEventListener('change', this.update);
        this.reducedMotion.addEventListener('change', this.update);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.desktop) this.desktop.removeEventListener('change', this.update);
        if (this.reducedMotion) this.reducedMotion.removeEventListener('change', this.update);
      }

      update() {
        if (this.visible && this.desktop.matches && !this.reducedMotion.matches) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-overview"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-po-toggle]');
    if (!toggle) return;

    const panel = toggle.closest('[data-po-panel]');
    const region = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel || !region) return;

    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    panel.classList.toggle('is-open', open);
    region.inert = !open;
  });

  document.addEventListener('shopify:block:select', (event) => {
    const toggle = event.target.closest('[data-po-panel]')?.querySelector('[data-po-toggle][aria-expanded="false"]');
    if (toggle) toggle.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video-banner"] && !Shopify.designMode) return;
  try {
    
  /* Locks the banner height in px so it can't track the mobile address bar.
     Firefox iOS resizes its WebView when its toolbar collapses and resolves
     lvh/svh/dvh against the live height (unlike Safari/Chrome iOS), so no CSS
     viewport unit stays fixed there. We measure 100lvh once and expose it as a
     px value (--vb-lvh) consumed by .video-banner__frame--* in theme.css.
     Re-measured only on orientation change — never on resize/scroll — so the
     toolbar hiding cannot change the locked value. */
  (function () {
    function lockViewportUnit() {
      var probe = document.createElement('div');
      probe.style.cssText =
        'position:absolute;top:0;left:0;width:0;height:100lvh;visibility:hidden;pointer-events:none;';
      document.body.appendChild(probe);
      var measured = probe.getBoundingClientRect().height;
      document.body.removeChild(probe);
      // Fall back to innerHeight if lvh is unsupported (old in-app webviews).
      if (!measured) measured = window.innerHeight;
      if (measured > 0) {
        document.documentElement.style.setProperty('--vb-lvh', (measured / 100) + 'px');
      }
    }
    lockViewportUnit();
    window.addEventListener('orientationchange', function () {
      // Let the viewport settle after rotation before re-measuring.
      setTimeout(lockViewportUnit, 300);
    });
  })();

  /* Hover scale on the CTAs, only when a page script has exposed motion
     (window.__DonkeyMotion, from card-carousel.js). Without it the buttons stay static. */
  (function () {
    function bindButtons(motion) {
      document.querySelectorAll('.section-video-banner .standard_cta').forEach(function (btn) {
        if (btn._vbHoverBound) return;
        btn._vbHoverBound = true;
        motion.hover(btn, function () {
          motion.animate(btn, { scale: 1.07 }, { duration: 0.2 });
          return function () { motion.animate(btn, { scale: 1 }, { duration: 0.2 }); };
        });
      });
    }

    function withMotion(fn) {
      if (window.__DonkeyMotion) fn(window.__DonkeyMotion);
      else document.addEventListener('donkey:motion-ready', function () { fn(window.__DonkeyMotion); }, { once: true });
    }

    withMotion(bindButtons);
    document.addEventListener('shopify:section:load', function () {
      if (window.__DonkeyMotion) bindButtons(window.__DonkeyMotion);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
